import type { ErrorView } from '../events';
import { errorView } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';

export const errorViewed = (context: TrackingContextValue, { errorCode }: Partial<ErrorView>) =>
  errorCode && errorView({ errorCode }, context);
